export const shuffle = <T>(array: readonly T[]): T[] => {
  const copy = [...array]
  if (copy.length <= 1) return copy

  for (let i = copy.length; i > 1; i -= 1) {
    const j = Math.floor(Math.random() * i)
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ;[copy[i - 1], copy[j]] = [copy[j]!, copy[i - 1]!]
  }
  return copy
}
